import LogoSvg from 'app/visuals/images/logo.svg?react';
import { Link } from 'react-router';
import { styled } from 'styled-components';

export const NAV_BAR_WIDTH = 108;

const LOGO_WIDTH = 40;
const LOGO_HEIGHT = 40;

export const StyledSideBar = styled.nav`
  position: absolute;
  background-color: ${({ theme }) => theme.colors.mono.ui02};
  width: ${NAV_BAR_WIDTH}px;
  height: 100vh; // Fallback for safety, in case --doc-height goes missing
  height: var(--doc-height);
  z-index: ${({ theme }) => theme.zIndex.headerBar + 1};
  display: flex;
  flex-direction: column;
  user-select: none;
`;

export const SideBarTitleContainer = styled.div`
  width: 100%;
`;

export const LogoLink = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: ${({ theme }) => theme.spacing(1)}px;
  padding: ${({ theme }) => theme.spacing(1.5)}px ${({ theme }) => theme.spacing(0.5)}px;
  cursor: pointer;

  && {
    color: ${({ theme }) => theme.colors.mono.text01};
    text-decoration: none;
  }
`;

export const Logo = styled(LogoSvg).attrs({ role: 'img' })`
  width: ${LOGO_WIDTH}px;
  height: ${LOGO_HEIGHT}px;
`;

export const NavItemIcon = styled.span<{ $isExternal?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
`;

export const SideBarLinkList = styled.div`
  flex: 1 1 1px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: auto;
  a {
    text-decoration: none;
  }
`;

export const NavItemLinkTitle = styled.span`
  width: 100%;
  max-width: 100%;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(0.5)}px;
  font-family: ${({ theme }) => theme.font.default.family};
  font-weight: ${({ theme }) => theme.font.default.weight.normal};
  font-size: 1.3rem;
  line-height: 1.1;
`;
